import {
  DrawerMenuItemNestedSubmenuType,
  DrawerMenuItemSubmenuItemType,
  DrawerMenuItemSubmenuType,
  DrawerMenuItemType,
  NavbarDropdownType,
  NavbarMenuItemHRType,
  NavbarMenuItemLinkType,
  NavbarMenuItemType,
} from "@/lib/types";

type NavbarSubmenuItemType =
  | NavbarMenuItemHRType
  | NavbarMenuItemLinkType
  | NavbarDropdownType;

function clampNavbarSubmenu(
  items: NavbarSubmenuItemType[],
  level: number,
  maxLevels: number,
): NavbarSubmenuItemType[] {
  return items.map((item) => {
    if (item.kind !== "submenu") return item;

    if (level >= maxLevels) {
      return {
        ...item,
        submenu: item.submenu.filter(
          (submenuItem) => submenuItem.kind !== "submenu",
        ),
      };
    }

    return {
      ...item,
      submenu: clampNavbarSubmenu(item.submenu, level + 1, maxLevels),
    };
  });
}

function limitNavbarMenuDepth(
  items: NavbarMenuItemType[],
  maxLevels = 3,
): NavbarMenuItemType[] {
  if (maxLevels < 1) return [];

  return items.map((item) => {
    if (item.kind !== "submenu") return item;

    if (maxLevels === 1) {
      return {
        ...item,
        submenu: item.submenu.filter(
          (submenuItem) => submenuItem.kind !== "submenu",
        ),
      };
    }

    return {
      ...item,
      submenu: clampNavbarSubmenu(item.submenu, 2, maxLevels),
    };
  });
}

function limitDrawerMenuDepth(items: DrawerMenuItemType[]): DrawerMenuItemType[] {
  const isNestedSubmenu = (
    item: DrawerMenuItemSubmenuItemType,
  ): item is DrawerMenuItemNestedSubmenuType => "submenu" in item;

  const clampDrawerSubmenu = (
    itemsToClamp: DrawerMenuItemSubmenuItemType[],
    level: number,
    maxLevels: number,
  ): DrawerMenuItemSubmenuItemType[] => {
    return itemsToClamp.map((item) => {
      if (!isNestedSubmenu(item)) return item;

      if (level >= maxLevels) {
        return {
          ...item,
          submenu: item.submenu.filter(
            (submenuItem) => !isNestedSubmenu(submenuItem),
          ),
        };
      }

      return {
        ...item,
        submenu: clampDrawerSubmenu(item.submenu, level + 1, maxLevels),
      };
    });
  };

  return items.map((item) => {
    if (item.kind !== "submenu") return item;

    const submenuItem = item as DrawerMenuItemSubmenuType;

    return {
      ...submenuItem,
      submenu: clampDrawerSubmenu(submenuItem.submenu, 2, 3),
    };
  });
}

export { limitDrawerMenuDepth, limitNavbarMenuDepth };
